import { gql } from '@apollo/client';

export const searchQueryTypes = gql`
  fragment QueryTypesFragment on SearchQuery {
    ... on DataTypeSearchCombo {
      dataType
      minMatch
      maxMatch
    }
    ... on GeoSearchField {
      dataType
      field
      comparatorType
      location {
        lat
        lon
      }
      distance {
        distance
        unit
      }
      dynamicValue
    }
    ... on MultiValueSearchField {
      dataType
      field
      comparatorType
      values
    }
    ... on SingleValueSearchField {
      dataType
      field
      comparatorType
      value
      dynamicValue
      fieldType
      castType
    }
  }
`;

export const searchCombo = gql`
  ${searchQueryTypes}
  fragment SearchComboFragment on SearchCombo {
    combinator
    searchQueries {
      ...QueryTypesFragment
    }
  }
`;

export const daysOfWeek = gql`
  fragment DaysFragment on SkipDaysOfWeek {
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
  }
`;

export const nodeResourceFragment = gql`
  ${searchCombo}
  fragment NodeResourceFragment on WorkflowNodeResource {
    ... on CampaignNodeResource {
      name
      campaign {
        name
        id
        ignoreFrequencyCap
        campaignState
        dataScienceOptimizations
        customQuietHours {
          startTime
          endTime
          sendSkip
        }
        displayUntil {
          endDate
          searchQuery {
            ...SearchComboFragment
          }
        }
      }
    }
    ... on ContactListNodeResource {
      name
    }
    ... on WebhookNodeResource {
      name
    }
    ... on MessageChannelNodeResource {
      name
    }
    ... on MessageTypeNodeResource {
      name
    }
    ... on MultiCampaignNodeResource {
      resources {
        campaign {
          id
          name
          customQuietHours {
            startTime
            endTime
            sendSkip
          }
        }
      }
    }
    ... on WorkflowNodeResource {
      name
    }
  }
`;
